import { t } from '@if/core/i18n'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { FC, useCallback } from 'react'

export interface StaleSimulationAlertProps {
  open: boolean
  onCancel: () => void
  onRefresh: () => void
  isRefreshing?: boolean
}

/**
 * Alert dialog shown when a calendar simulation has expired
 * Provides options to cancel the operation or refresh the simulation with fresh data
 */
const StaleSimulationAlert: FC<StaleSimulationAlertProps> = ({ open, onCancel, onRefresh, isRefreshing = false }) => {
  const handleClose = useCallback(() => {
    if (!isRefreshing) {
      onCancel()
    }
  }, [isRefreshing, onCancel])
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('loan.calendar.staleSimulation.title')}</DialogTitle>
      <DialogContent>{t('loan.calendar.staleSimulation.message')}</DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isRefreshing} color="inherit">
          {t('loan.calendar.staleSimulation.cancel')}
        </Button>
        <Button onClick={onRefresh} loading={isRefreshing} color="primary">
          {t('loan.calendar.staleSimulation.refresh')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default StaleSimulationAlert
